export default __webpack_public_path__ + "static/media/takeAPunt.bdd0deef.png";